import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {BusinessRegion, ResponsiblePerson} from "../../models/ic/ic";

export class ICService {
    api: AxiosInstance = API;

    getAllRegions(): Promise<BusinessRegion[]> {
        return this.api.get('ic/regions').then(x => x.data);
    }

    getAllPersons(): Promise<ResponsiblePerson[]> {
        return this.api.get('ic/responsible-persons').then(x => x.data);
    }
}

export const icService = new ICService();
